import { render, staticRenderFns } from "./HeaderCompo.vue?vue&type=template&id=638ee60c&scoped=true&"
import script from "./HeaderCompo.vue?vue&type=script&lang=js&"
export * from "./HeaderCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ee60c",
  null
  
)

export default component.exports